var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.92254V8.68604H15.75V16.2439C15.75 16.3775 15.6973 16.5057 15.6036 16.6002C15.5098 16.6947 15.3826 16.7478 15.25 16.7478H2.75C2.61739 16.7478 2.49021 16.6947 2.39645 16.6002C2.30268 16.5057 2.25 16.3775 2.25 16.2439V8.68604H1.25V6.92254L8.7025 1.34987C8.78859 1.28564 8.89288 1.25098 9 1.25098C9.10712 1.25098 9.2114 1.28564 9.2975 1.34987L16.75 6.92254Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.9691C10.7949 12.9691 12.25 11.5028 12.25 9.69402C12.25 7.88525 10.7949 6.41895 9 6.41895C7.20507 6.41895 5.75 7.88525 5.75 9.69402C5.75 11.5028 7.20507 12.9691 9 12.9691Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.69416C7.25 9.22646 7.43437 8.7779 7.76256 8.44718C8.09075 8.11646 8.53587 7.93066 9 7.93066",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0181 10.9082L13.3256 12.2283C13.5835 12.5067 13.724 12.8751 13.7175 13.2558C13.711 13.6366 13.558 13.9999 13.2908 14.2691C13.0236 14.5384 12.6631 14.6926 12.2853 14.6991C11.9074 14.7057 11.5419 14.5641 11.2656 14.3042L9.82812 12.8581",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.85bec141.svg";
export { ForwardRef as ReactComponent };